






import screenfull from 'screenfull';
import { Component, Vue } from 'vue-property-decorator';

/** document hooks */
const sf: any = screenfull;

/** document hooks */
@Component({
	name: 'Screenfull'
})
/** Screenfull */
export default class Screenfull extends Vue {
	/** document hooks */
	private isFullscreen: any = false;

	/** document hooks */
	public mounted(): any {
		if (sf.isEnabled) {
			sf.on('change', this.change.bind(this));
		}
	}

	/** document hooks */
	public beforeDestory(): any {
		if (sf.isEnabled) {
			sf.off('change', this.change.bind(this));
		}
	}

	/** document hooks */
	private change(): any {
		if (sf.isEnabled) {
			this.isFullscreen = sf.isFullscreen;
		}
	}

	/** document hooks */
	private click(): any {
		if (!sf.isEnabled) {
			this.$message({
				message: 'you browser can not work',
				type: 'warning'
			});

			return false;
		}

		sf.toggle();
	}
}
